<template>
  <!--行政区选择组件 -->
  <el-dialog :title="title" style="color:white" :visible.sync="dialogFormVisible" append-to-body
    custom-class="mainDialog">
    <el-radio-group v-model="bradio" class="radiobuttons" v-if="$route.path === '/subscriptionData'"
      @change="radioClick">
      <el-radio v-model="bradio" label="1">行政区划</el-radio>
      <el-radio v-model="bradio" label="2">经纬度</el-radio>
    </el-radio-group>
    <div class="titlebuttons">
      <el-button size="small" type="success" class="cshi" v-for="(button,index) in buttons" :key="index"
        @click="swbutton(index)">{{button.name}}</el-button>
    </div>
    <div class="infobody">
      <div :key="tag.regioncode" class="idtag" v-for="tag in dynamicTags" :disable-transitions="false">
        <el-tag @click="handleCilck(tag)" class="idtaginfo">
          {{tag.regionname}}
        </el-tag>
      </div>
    </div>
    <div style="margin-top: 20px;text-align: center;" v-if="$route.path === '/subscriptionData'">
      <el-button class="buttongteys" @click="preStep">上一步</el-button>
      <el-button style="margin-left: 60px;" class="buttongtey" type="primary" @click="nextStep">下一步</el-button>
    </div>
    <div style="margin-top: 20px;text-align: center;" v-else>
      <el-button class="buttongtey" type="primary" @click="choseregion">确 定</el-button>
      <el-button style="margin-left: 60px;" class="buttongteys" @click="deleteregion">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Map from '../../common/map/Tmap.js'
export default {
  name: 'HeadBoundaryDialog',
  props: ['msgFather', 'prodata', 'radio'],
  data () {
    return {
      dialogFormVisible: false,
      dynamicTags: [],
      buttons: [{
        code: '',
        name: '省/直辖市'
      }],
      selectregioncode: '',
      regioncode: '',
      type: '',
      bradio: '1',
      regionname: ''
    }
  },
  created () {
    this.dynamicTags = this.prodata
    console.log(this.datainfos)
  },
  computed: {
    title () {
      return this.$route.path === '/subscriptionData' ? '空间范围' : '行政区域选择'
    }
  },
  methods: {
    choseregion () {
      this.dialogFormVisible = false
    },
    radioClick (val) {
      if (val === '2') {
        this.$emit('showWeftDialog', val)
      }
    },
    nextStep () {
      this.dialogFormVisible = false
      this.$emit('getSetdialogFormVisible', true)
      this.sendMsgToParentPro()
    },
    preStep () {
      this.dialogFormVisible = false
      this.$emit('getdaydialogFormVisible', true)
    },
    deleteregion () {
      this.dialogFormVisible = false
      document.getElementById('fooderxzqy').innerHTML = ''
      Map.ClearOverSource()
    },
    swbutton: function (index) {
      if (index === 0) {
        this.buttons = [{
          code: '',
          name: '省/直辖市'
        }]
        this.dynamicTags = this.prodata
      } else if (index === 1) {
        this.buttons[1].code = ''
        this.buttons[1].name = '城市'
        this.buttons.splice(2, 1)
        this.switchcity(1)
      }
      var fooderxzqy = ''
      this.buttons.forEach((item, index) => {
        if (item.name !== '城市' && item.name !== '县市/区' && item.name !== '省/直辖市') {
          if (index !== 0) {
            fooderxzqy += '-' + item.name
          } else {
            fooderxzqy += item.name
          }
        }
      })
      document.getElementById('fooderxzqy').innerHTML = fooderxzqy
      document.getElementById('drawstyle1').innerHTML = ''
      document.getElementById('drawstyle2').innerHTML = ''
      document.getElementById('drawstyle3').innerHTML = ''
      document.getElementById('drawstyle4').innerHTML = ''
    },
    // 选择行政区
    sendMsgToParent: function () {
      this.$emit('getboundarydialogFormVisible', this.dialogFormVisible)
    },
    sendMsgToParentPro: function () {
      this.$emit('getRegioncode', {
        code: this.regioncode,
        type: this.type,
        regionname: this.regionname
      })
    },
    handleCilck: function (tag) {
      if (this.buttons[0].name === '省/直辖市') {
        this.buttons[0].code = tag.regioncode
        this.buttons[0].name = tag.regionname
        this.regioncode = tag.regioncode
        this.type = 'province'
        this.regionname = tag.regionname
        this.sendMsgToParentPro()
        var city = {
          code: '',
          name: '城市'
        }
        this.buttons.push(city)
        this.switchcity(1)
      } else if (this.buttons.length === 2 && this.buttons[1].name === '城市') {
        this.buttons[1].code = tag.regioncode
        this.buttons[1].name = tag.regionname
        this.regionname = tag.regionname
        this.regioncode = tag.regioncode
        this.type = 'city'
        this.sendMsgToParentPro()
        var xian = {
          code: '',
          name: '县市/区'
        }
        this.buttons.push(xian)
        this.switchcity(2)
      } else if (this.buttons.length === 3 && this.buttons[2].name === '县市/区') {
        this.buttons[2].code = tag.regioncode
        this.buttons[2].name = tag.regionname
        this.regionname = tag.regionname
        this.regioncode = tag.regioncode
        this.type = 'xian'
        this.sendMsgToParentPro()
      }
      var fooderxzqy = ''
      this.buttons.forEach((item, index) => {
        if (item.name !== '城市' && item.name !== '县市/区' && item.name !== '省/直辖市') {
          console.log(item)
          if (index !== 0) {
            fooderxzqy += '-' + item.name
          } else {
            fooderxzqy += item.name
          }
        }
      })
      document.getElementById('fooderxzqy').innerHTML = fooderxzqy
    },
    // 城市选择列表后台接口
    switchcity: function (code) {
      if (code === 1) {
        var josndata = {
          type: 'city',
          code: this.buttons[0].code
        }
        this.sapost('/dmc/manage/standardProduct/regionList', josndata, r => {
          this.dynamicTags = r.data
        })
      } else if (code === 2) {
        var josndatas = {
          type: 'xian',
          code: this.buttons[1].code
        }
        this.sapost('/dmc/manage/standardProduct/regionList', josndatas, r => {
          this.dynamicTags = r.data
        })
      }
    }
  },
  watch: {
    msgFather: function (curVal) {
      this.dialogFormVisible = curVal
    },
    dialogFormVisible: function () {
      this.sendMsgToParent()
    },
    prodata: function (data) {
      this.dynamicTags = data
    },
    radio (val) {
      this.bradio = val
    }
  }
}
</script >
<style >
.idtaginfo {
  border-radius: 5px;
  background-color: #ffffff;
  color: #18bc9c;
  border: 0px;
}
.idtaginfo:hover {
  border-radius: 5px;
  background-color: #18bc9c;
  color: #ffffff;
  border: 1px #18bc9c solid;
  cursor: pointer;
}
.idtag {
  margin-top: 5px;

  width: 20%;
}
.infobody {
  border-top: 1px #18bc9c solid;
  border-bottom: 1px #18bc9c solid;
  width: 90%;
  margin-left: 5%;
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.el-button--success {
  margin-left: 0px;
  color: #fff;
  background-color: #18bc9c;
  border-color: #18bc9c;
  margin-right: 10px;
}
.radiobuttons {
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
  text-align: left;
  border-bottom: 1px #606266 solid;
}
.titlebuttons {
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
  text-align: left;
}
.el-dialog__title {
  line-height: 1px;
  font-size: 16px;
  color: #ffffff;
}
.el-range-editor.el-input__inner {
  display: -webkit-inline-box;
  width: 80%;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 3px 10px;
}
.cshi {
  padding: 7px 7px;
}
.el-dialog__header {
  background: #1d202f;
  border-radius: 8px 8px 0 0;
  height: 1.25rem;
}
.dialog__header span {
  color: white;
}
/* .el-dialog {*/
.mainDialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 66%;
  margin-left: 17%;
  min-width: 670px;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadMenu/HeadBoundaryDialog.vue